// import { Component, ViewChild } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Conditional } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ToastrService } from 'ngx-toastr';
// import { register } from 'module';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrl: './otp-verification.component.scss',
})
export class OtpVerificationComponent implements OnInit{
  otp: any;
  email : any;
  constructor( private api:ApiServiceService , private toastr: ToastrService, private route: ActivatedRoute){}


  ngOnInit(){
   
    }
    ngAfterViewInit(){
      this.route.paramMap.subscribe((value: any)=>{
        this.email = value.params.email;
      })
    }

  
  showOtpComponent = true;
  @ViewChild('ngOtpInput') ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    inputStyles: {
      'width': '50px',
      'height': '50px',
      "color" : 'purple',
      "border-color" : 'purple'
    }
  };
  
  onOtpChange(event : any) {
    this.otp = event;
  }

  setVal(val : any) {
    this.ngOtpInput.setValue(val);
  }

  onConfigChange() {
    this.showOtpComponent = false;
  this.otp;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }


  verifyOtp() {
    // Mock verification logic
    const param = {
      otp: this.otp
    }
  this.api.verifyOtp(param).subscribe((res:any)=>{
    if(res.success){
      this.toastr.success('otp verified successfully');
    }else{
      this.toastr.error(res.message); 
    }
  },((error)=>{
    // console.log('error', error)
  }))
  }


  resendOtp() {
    // Mock verification logic
    const param = {
      email: this.email

    }
  this.api.resendOtp(param).subscribe((res:any)=>{
    if(res.success){
      this.toastr.success('otp resend successfully');
      
    }
  },((error)=>{
    // console.log('error', error)
  }))
  }
}


  